<template>
  <div class="voice">
    <div v-show="document_width<768" class="header-bg">
      <div class="header">
        <div class="logo">
          <img />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="left-item">
        <div class="header">
          <div class="logo">
            <img />
          </div>
        </div>
        <div class="sub-item" v-for="(item,index) in questions" :key="index">
          <p class="tit" v-html="item.cn"></p>
          <p class="tit" v-html="item.en"></p>
          <el-rate v-if="index===0" :colors="colors" v-model="rate"></el-rate>
          <textarea class="con" v-if="index!==0 && index!==5 && index!==6" v-model="item.answer"></textarea>
          <el-input v-if="index===5" class="email-con" v-model="email"></el-input>
          <label v-if="index===6" class="tit"></label>
        </div>
        <el-button
          @click="sendVoice"
          class="sub-btn"
          v-loading="btnLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-custom-class="btn-loading"
          :disabled="btnLoading"
        >SUBMIT (提交)</el-button>
      </div>
      <div class="right-item">
        <div class="img-box">
          <img src="../assets/imgs/wibot-animated.png" />
        </div>
      </div>
      <div @click="messageIsShow=false" v-show="messageIsShow" class="message-box">
        <div class="message">
          <div class="header">
            <i @click="messageIsShow=false" class="el-icon-close"></i>
          </div>
          <div class="tit">
            <h1>謝謝</h1>
            <h1>Thank You</h1>
          </div>
          <div class="con">
            <p>你已成功提交意見</p>
            <p>Your submission has been sent</p>
          </div>
          <div class="btn">
            <el-button @click="$router.push('/Home')" class="sub-btn">CHECK OUT WIDI (想了解WIDI)</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendVoice } from "../api/register.js";
export default {
  data() {
    return {
      document_width: document.body.clientWidth,
      colors:
        document.body.clientWidth > 768
          ? ["#3D9DA2", "#3D9DA2", "#3D9DA2"]
          : ["#fff", "#fff", "#fff"],
      rate: null,
      email: null,
      questions: [
        {
          cn: "你對於現屆理事過去一年的工作滿意程度（1:最低;5.最高)",
          en:
            "Your satisfaction towards current council members (1:lowest; 5:highest)",
          answer: ""
        },
        {
          cn: "你最希望理事會在未來一年能夠處理的問題",
          en: "Issue you wish the council can handle in the coming year",
          answer: ""
        },
        {
          cn: "你過往有否接觸過任何SaaS會計/審計軟件？如有,請提供名稱",
          en:
            "Have you ever used any SaaS accoutning/auditing software? If yes, please provide the software name.",
          answer: ""
        },
        {
          cn: "你認為行業在數碼化轉型上面對的最大困難是",
          en:
            "What do you think is the biggest difficulty facing by the industry in digital transformation?",
          answer: ""
        },
        {
          cn: "你認為公會在行業數碼化轉型上應對會員提供什麼幫助",
          en:
            "What kind of assistance do you think the Institute should provide to its members regarding digital transformation?",
          answer: ""
        },
        {
          cn: "你的電郵地址",
          en: "You email address",
          answer: ""
        },
        {
          cn: "Thank You！",
          en: "謝謝！",
          answer: ""
        }
      ],
      messageIsShow: false,
      btnLoading: false
    };
  },
  methods: {
    // 提交
    sendVoice() {
      // 非空验证
      if (!this.email || !this.rate) {
        this.$message.error("Score and email cannot be empty");
        return;
      }
      // 验证邮箱
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!regEmail.test(this.email)) {
        this.$message.error("Please check your email");
        return;
      }
      const data = {
        email: this.email,
        rate_level: this.rate,
        questions: []
      };
      for (const key in this.questions) {
        if (!["0", "5", "6"].includes(key)) {
          data.questions.push(this.questions[key]);
        }
      }
      this.btnLoading = true;
      sendVoice(data)
        .then(res => {
          if (res.result === "success") {
            this.messageIsShow = true;
          } else {
            this.$message.error("Failed to submit. Please try again later");
          }
          this.btnLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.$message.error("Failed to submit. Please try again later");
          this.btnLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.voice {
  .header-bg {
    .header {
      height: 80px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      .logo {
        height: 30px;
        width: 140px;
        img {
          width: 100%;
          cursor: pointer;
          content: url("../assets/imgs/widi-logo.png");
        }
      }
    }
  }
  .container {
    max-width: 1366px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .sub-btn {
      width: 220px;
      line-height: 50px;
      background: rgba(35, 189, 139, 1);
      font-size: 15px;
      color: white;
      padding: 0;
    }
    .left-item {
      width: 41%;
      padding: 0 50px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .header {
        display: flex;
        align-items: center;
        margin: 40px 0 48px;
        .logo {
          height: 30px;
          width: 140px;
          img {
            width: 100%;
            cursor: pointer;
            content: url("../assets/imgs/widi-logo.png");
          }
        }
      }
      .sub-item {
        margin-bottom: 30px;
        .tit {
          font-size: 16px;
          font-family: "Regular";
          line-height: 24px;
          color: #000000;
        }
        .el-rate {
          margin: 30px 0;
          .el-rate__icon {
            font-size: 21px;
          }
        }
        .con {
          width: 100%;
          height: 100px;
          border: 1px solid rgba(189, 195, 199, 1);
          border-radius: 3px 3px 3px 3px;
          font-size: 18px;
          color: #606266;
          outline: none;
          font-size: 16px;
          resize: none;
          padding: 15px 0 0 15px;
          margin-top: 15px;
          box-sizing: border-box;
        }
        .email-con {
          margin-top: 15px;
        }
      }
    }
    .right-item {
      width: 59%;
      background: url(/img/widi-yourvoice-gradient.d06fc6fa.png);
      .img-box {
        position: fixed;
        top: 50%;
        width: 100%;
        max-width: px;
        transform: translateY(-50%);
        left: 55%;
        max-width: 383px;
        & > img {
          width: 100%;
        }
      }
    }
    .message-box {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: fixed;
      top: 0;
      left: 0;
      .message {
        width: 465px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        text-align: center;
        border-radius: 5px;
        color: black;
        .header {
          margin: 40px 0 55px;
          text-align: right;
          .el-icon-close {
            cursor: pointer;
            margin-right: 20px;
          }
        }
        .tit {
          & > h1 {
            font-family: "InterBold";
          }
        }
        .con {
          margin: 35px 0;
          font-family: none;
        }
        .sub-btn {
          width: unset;
          padding: 0 20px;
          margin-bottom: 110px;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .header-bg {
      background: url(/img/widi-yourvoice-gradient.d06fc6fa.png);
      .header {
        .logo {
          content: url("../assets/imgs/widi-mono-white.png");
        }
      }
    }
    .container {
      color: white;
      .left-item {
        width: unset;
        margin: 0;
        padding: 0 20px 20px;
        background: url("../assets/imgs/widi-yourvoice-gradient.png");
        .header {
          display: none;
        }
        .sub-btn {
          display: block;
          margin: 0 auto;
          border-color: #23bd8b;
        }
        .sub-item {
          .tit {
            color: white;
            font-size: 15px;
          }
          .el-rate {
            margin: 20px 0;
          }
        }
      }
      .right-item {
        display: none;
      }
      .message-box {
        .message {
          width: 92%;
          .header {
            margin: 15px 0 25px;
          }
          .sub-btn {
            margin-bottom: 30px;
          }
        }
      }
    }
  }
}
</style>
